import React from 'react';
const UnauthorizedPage = () => {

  return (
    <div className="container min-h-screen flex items-center justify-center">
      <div className="w-full max-w-xl mx-auto px-4">
        <div className="bg-white rounded-xl shadow-xl overflow-hidden">
          <div className="p-8 md:p-12">
            <h1>

            </h1>

            <h1>
                
            </h1>
            <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Unauthorized Access
            </h1>
            <div className="bg-gray-50 rounded-lg p-8">
              <p className="text-gray-600 text-lg text-center leading-relaxed">
                Sorry, you don't have permission to access this page. 
                This area is restricted to authorized users only.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
